import { Button, Dropdown, Input, List, Menu, Modal, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { DownOutlined,} from '@ant-design/icons';
import IF from '@/components/IF';
import {
    SearchSvgComponent,
    SoilCloseIcon,
    SoilProfileSelectedActionIcon,
    SoilProfileStateClear,
    SoilSearchCheckBoxUnSelected,
    SoilSearchSelectedIcon
} from '@/resource/IconComponentSets';
import {
    soilProfileGetLayersDetail,
    soilProfileGetSoilProfileDetail,
    soilSearchDownloadBriefProfiles,
} from '@/util/Request';
import {
    GetPropertyListResponseModel,
    ISoilProfileGetLayersDetailResModel,
    ISoilProfileGetSoilDetailResModel,
    ISoilSearchProfileDetailModel,
    ISoilSearchProfileLayerInfoModel,
    ISoilSearchTableViewResModel
} from '@/util/Request/requestType';
import Download from '../../../soil-profile/Component/Download';
import './index.less';
import SoilProfilePreview from '@/page/Soil/soil-profile/Component/SoilProfilePreview';

interface IProps {
    id?: string
    propertySet: GetPropertyListResponseModel[]
    soilSearchTableviewData: ISoilSearchTableViewResModel[]
    splitByCountryCallback: (splitByCountry: boolean) => void
    spining: boolean
    currentPage: string
}

interface ISoilProperty {
    layerName: string
    startDepth: number
    endDepth: number
    method: string
    propertyCategory: string
    propertyName: string
    propertyValue: string
    propertyUnit: string
}

const SoilSearchDetailComponent = (props: IProps) => {
    const {
        propertySet,
        soilSearchTableviewData,
        splitByCountryCallback,
        spining,
        currentPage
    } = props;

    // SECTION: state defined here
    const [operationVisible, setOperationVisible] = useState(false);
    const [selectedCount, setSelectedCount] = useState(0);
    const [downloadVisible, setDownloadVisible] = useState(false);
    const [downloadSpining, setDownloadSpining] = useState(false);
    const [splitByCountry, setSplitByCountry] = useState(false);
    const [localSoilSearchTableViewList, setLocalSoilSearchTableViewList] = useState(soilSearchTableviewData);
    const [profileDetailVisible, setProfileDetailVisible] = useState(false);
    const [layerDetail, setLayerDetail] = useState<ISoilProfileGetLayersDetailResModel[]>();
    const [profileDetail, setProfielDetail] = useState<ISoilProfileGetSoilDetailResModel>();
    const [profileDatailSpin, setProfileDatailSpin] = useState(false);


    const selectedProfileCodeRef = useRef([]);

    // SECTION: Funtion area
    const splitByAllButtonClick = () => {
        setSplitByCountry(false);
        splitByCountryCallback(false);
    };

    // hand filter the list
    const handleInpuBlur = (e) => {
        const value = e.target.value;

        if (value.length === 0) {
            return setLocalSoilSearchTableViewList(soilSearchTableviewData);
        }

        const regExp = new RegExp(value, 'i');

        const passTheTestArr = [];
        for (const listItem of soilSearchTableviewData) {
            const result = JSON.stringify(listItem).match(regExp);
            const newList = [];
            listItem.profileDetailList.forEach(profileDetail => {
                const result = JSON.stringify(profileDetail).match(regExp);
                if (result) {
                    newList.push(profileDetail);
                }
            });
            const newListItem = {
                ...listItem,
                profileDetailList: newList
            };
            if (result) {
                passTheTestArr.push(newListItem);
            }
        }
        setLocalSoilSearchTableViewList(passTheTestArr);
    };

    const splitByRegionButtonClick = () => {
        setSplitByCountry(true);
        splitByCountryCallback(true);
    };

    const fetchProfilePreviewData = async (profileCode, profileId) => {
        try {
            setProfileDatailSpin(true);
            const profileDetail = await soilProfileGetSoilProfileDetail(profileCode);
            const layerDetail = await soilProfileGetLayersDetail(profileId);
            setLayerDetail(layerDetail);
            setProfielDetail(profileDetail);
            setProfileDatailSpin(false);
        } catch(err) {
            console.log('err', err);
        }
    };

    const onClickTargetRow = (record) => {
        const profileId = record.profileID;
        const profileCode = record.profileCode;
        if (profileId > 1000) {
            return;
        }
        fetchProfilePreviewData(profileCode, profileId);
        setProfileDetailVisible(true);
    };

    const handleOrRmProfileId = (add: boolean, profileCode: number) => {
        if (add) {
            if (!selectedProfileCodeRef.current.includes(profileCode)) {
                selectedProfileCodeRef.current.push(profileCode);
            }
        } else {
            const targetIndex = selectedProfileCodeRef.current.indexOf(profileCode);
            selectedProfileCodeRef.current.splice(targetIndex, 1);
        }
    };

    const handleDouwnload = async () => {
        try {
            if (downloadSpining) {
                return;
            }
            setDownloadSpining(true);
            const profileIds = selectedProfileCodeRef.current.join(',');
            const propertyIdArr = propertySet.map((item) => item.id);
            const propertIds = propertyIdArr.join(',');
            const date = moment().format('DD-MMM-YYYY');
            const fileName = `PROFILE-${date}.xlsx`;

            await soilSearchDownloadBriefProfiles(
                profileIds,
                propertIds,
                fileName,
                'xlsx',
            );
            setDownloadSpining(false);
        } catch (err) {
            setDownloadSpining(false);
        }
    };

    const selectAllCategoryButtonClick = (soilPropertySet: ISoilSearchTableViewResModel) => {
        let currentCategorySelectedArrayIndex = 0;
        let currentCategoryAlreadySelectedCount = 0;
        let cacheSoilSearchTableviewData = [];
        if (localSoilSearchTableViewList && localSoilSearchTableViewList.length > 0) {
            cacheSoilSearchTableviewData = [...localSoilSearchTableViewList];
        } else {
            cacheSoilSearchTableviewData = [...soilSearchTableviewData];
        }
        let allSelected;
        const newCacheSoilSearchTableviewData = cacheSoilSearchTableviewData.map((item) => {
            if (item.category === soilPropertySet.category) {
                //get current index
                const categoryIndex = cacheSoilSearchTableviewData.findIndex((value) => {
                    return value.category == item.category;
                });
                currentCategorySelectedArrayIndex = categoryIndex;
                const newItem = { ...item };
                allSelected = !soilPropertySet.selected;
                newItem.selected = allSelected;
                if (!operationVisible && !soilPropertySet.selected) {
                    setOperationVisible(true);
                }
                const cacheProfileDetailList = [...newItem.profileDetailList];
                const newProfileDetailList = cacheProfileDetailList.map(profile => {
                    console.log('all item:', profile);
                    if (profile.selected && profile.selected == true) {
                        currentCategoryAlreadySelectedCount++;
                    }
                    const newProfile = { ...profile };
                    if (newProfile.selected === !soilPropertySet.selected) {
                        return newProfile;
                    }
                    newProfile.selected = !soilPropertySet.selected;
                    // handle the profile id add or remove
                    handleOrRmProfileId(!soilPropertySet.selected, profile.profileCode);
                    return newProfile;
                });
                newItem.profileDetailList = newProfileDetailList;
                return newItem;
            }
            return item;
        });
        if (allSelected) {
            setSelectedCount(selectedCount + newCacheSoilSearchTableviewData[currentCategorySelectedArrayIndex].profileDetailList.length - currentCategoryAlreadySelectedCount);
        }
        else {
            setSelectedCount(selectedCount - newCacheSoilSearchTableviewData[currentCategorySelectedArrayIndex].profileDetailList.length);
        }
        setLocalSoilSearchTableViewList(newCacheSoilSearchTableviewData);
    };

    const selectTargetItemButtonClick = async (soilPropertySet: ISoilSearchTableViewResModel , profileDetail: ISoilSearchProfileDetailModel) => {
        let cacheSoilSearchTableviewData = [];
        if (localSoilSearchTableViewList && localSoilSearchTableViewList.length > 0) {
            cacheSoilSearchTableviewData = [...localSoilSearchTableViewList];
        } else {
            cacheSoilSearchTableviewData = [...soilSearchTableviewData];
        }
        let allSelected = false;
        const newCacheSoilSearchTableviewData = cacheSoilSearchTableviewData.map((item) => {
            if (item.category === soilPropertySet.category) {
                const newItem = {...item};
                const cacheProfileDetailList = [...newItem.profileDetailList];
                let count = selectedCount;
                const newProfileDetailList = cacheProfileDetailList.map(profile => {
                    if (profile.profileID === profileDetail.profileID) {
                        const newProfile = { ...profile };
                        newProfile.selected = !profile.selected;
                        if (!operationVisible && !profile.selected) {
                            setOperationVisible(true);
                        }
                        if (!profile.selected) {
                            count = (count + 1);
                            console.log(' change to true: ', count);
                            let tmpFlag=true;
                            cacheProfileDetailList.forEach((itemDetail) => {
                                if (itemDetail.profileID != newProfile.profileID && !itemDetail.selected)
                                {
                                    tmpFlag = false;
                                }
                            });
                            allSelected = tmpFlag;
                        } else {
                            allSelected = false;
                            count = (count - 1);
                            console.log(' change to false: ', count);
                        }
                        handleOrRmProfileId(!profile.selected, profile.profileCode);

                        return newProfile;
                    }
                    return profile;
                });
                setSelectedCount(count);
                newItem.profileDetailList = newProfileDetailList;
                newItem.selected = allSelected;
                return newItem;
            }
            return item;
        });
        setLocalSoilSearchTableViewList(newCacheSoilSearchTableviewData);
    };

    const renderPropertiesVaueList = (soilAnalysis: ISoilSearchProfileLayerInfoModel[]) => {
        const soilPropertiesArr: ISoilProperty[] = [];
        soilAnalysis.forEach((analysis) => {
            analysis.samples.forEach((sample) => {
                sample.propertyValues.forEach((propertyValue) => {
                    const constructObj:ISoilProperty = {
                        layerName: '',
                        startDepth: 0,
                        endDepth: 0,
                        method: '',
                        propertyCategory: '',
                        propertyName: '',
                        propertyValue: '',
                        propertyUnit: ''
                    };
                    constructObj.layerName = analysis.layer;
                    constructObj.startDepth = sample.startDepth;
                    constructObj.endDepth = sample.endDepth;
                    constructObj.method = propertyValue.methodName;
                    constructObj.propertyCategory = propertyValue.propertyClass;
                    constructObj.propertyName = propertyValue.propertyName;
                    constructObj.propertyValue = ' '+propertyValue.propertyValue;
                    constructObj.propertyUnit = propertyValue.unitCode;
                    soilPropertiesArr.push(constructObj);
                });
            });
        });

        const renderList = (
            <div className='whole-property-container-div'>
                {soilPropertiesArr.map((item, index) => (
                    <div className='property-value-container-div' key={`${item.layerName}-${item.startDepth}-${index}`}>
                        <div className='first-div-style'>
                            <span className={item.propertyCategory === 'Chemical' ?
                                'chemical-style' : 'physical-style' }>{item.propertyCategory.toUpperCase()}</span>
                            <span>{item.propertyName}</span>
                            <span>{item.propertyValue}</span>
                            <span>{item.propertyUnit}</span>
                        </div>
                        <div>
                            <span>{item.method}</span>
                        </div>
                        <div className='third-div'>
                            <span>{item.layerName}</span>
                            <span>{`(${item.startDepth}-${item.endDepth} cm)`}</span>
                        </div>
                    </div>
                ))}
            </div>
        );
        return renderList;
    };


    // SECTION: useEffect area
    useEffect(() => {
        setSelectedCount(0);
    }, [soilSearchTableviewData]);

    useEffect(() => {
        setLocalSoilSearchTableViewList(soilSearchTableviewData);
    }, [soilSearchTableviewData]);

    const items = [
        { label: 'All', key: 'all', onClick: () => splitByAllButtonClick()},
        { label: 'Split by country', key: 'split-by-region', onClick: () => splitByRegionButtonClick()}
    ];
    // SECTION: define the menus
    const menus = <Menu items={items} />;

    // SECTION: render the ui
    return (
        <div
            className='soil-search-profile-list-container'
        >
            <Spin spinning={spining}>
                <Modal
                    open={downloadVisible}
                    onOk={() => setDownloadVisible(false)}
                    onCancel={() => setDownloadVisible(false)}
                    style={{
                        height: 'auto',
                        position: 'absolute',
                        right: '100px',
                        top: '300px',
                    }}
                    className='down-load-modal'
                    title='Choose file format'
                    closeIcon={<SoilCloseIcon />}
                >
                    <Spin spinning={downloadSpining}>
                        <Download
                            titles={['PDF', 'XLS']}
                            className='down-load-div-container'
                            selectSpecifyType={() => handleDouwnload()}
                            cacncelDownload={() => {
                                setDownloadVisible(false);
                            }}
                        />
                    </Spin>
                </Modal>
                <IF show={operationVisible}>
                    <div className='operation-div'>
                        <div className='left-div'>
                            <SoilProfileSelectedActionIcon />
                            <span className='operation-panel'>{`Select ${selectedCount} Soil Profiles for actions`}</span>
                        </div>
                        <div className='right-div'>
                            <Button type='primary' onClick={() => handleDouwnload()} loading={downloadSpining} className='right-div-button'>
                                Download
                            </Button>
                            <button onClick={() => setOperationVisible(false)}>
                                <SoilProfileStateClear />
                            </button>
                        </div>
                    </div>
                </IF>
                <div className='upper-control-div'>
                    <Input
                        placeholder='Search'
                        prefix={<SearchSvgComponent />}
                        className='soil-search-table-view-input'
                        onBlur={handleInpuBlur}
                    />
                    <Dropdown
                        className="drop-down-list"
                        overlay={menus}
                        trigger={['click']}
                    >
                        <a
                            className="ant-dropdown-link"
                            onClick={e => e.preventDefault()}
                        >
                            <button className='exchange-buttton'>{splitByCountry ? 'Split By Country' : 'All'}<DownOutlined style={{fontSize:10, marginLeft: '8px'}}/></button>
                        </a>
                    </Dropdown>
                </div>
                <div id='table-list-container-window' className='table-own-div'>
                    <List
                        className='table-list'
                        id='soil-seatch-detail-component'
                        dataSource={localSoilSearchTableViewList}
                        renderItem={(item) => {
                            let category = item.category;
                            if (currentPage === '1') {
                                if (!item.category) {
                                    return category = '';
                                }
                                const arr = item.category && item.category.replace('(', '').replace(')', '').split(',');
                                const revert = arr.reverse().join(',');
                                category = `(${revert})`;
                            }
                            return (
                                <div className='soil-search-list-item'>
                                    <IF show={item.category && item.category.length > 0 && item.profileDetailList.length > 0}>
                                        <div className='category-div'>
                                            <button className='selected-button' onClick={() => selectAllCategoryButtonClick(item)}>
                                                {item.selected ? <SoilSearchSelectedIcon /> : <SoilSearchCheckBoxUnSelected />}
                                            </button>
                                            <span>{category}</span>
                                        </div>
                                    </IF>
                                    {item.profileDetailList.map((profile) => {
                                        let maxDepth = 1;
                                        for (const item of profile.soilLayerList) {
                                            if(item.layerEndDepth > maxDepth) {
                                                maxDepth = item.layerEndDepth;
                                            }
                                        }
                                        return (
                                            <div key={profile.profileCode} className='profile-layer-container' onClick={() => onClickTargetRow(profile)}>
                                                <div className='check-box-div'>
                                                    <div>
                                                        <button className='selected-button' onClick={() => selectTargetItemButtonClick(item, profile)}>
                                                            {
                                                                profile.selected ? <SoilSearchSelectedIcon /> : <SoilSearchCheckBoxUnSelected />
                                                            }
                                                        </button>
                                                        <span>{profile.profileName}</span>
                                                    </div>
                                                    <div>{profile.profileCode}</div>
                                                </div>
                                                <div className='title-container-div'>
                                                    <div>Location</div>
                                                    <div>Type</div>
                                                    <div>Max Depth</div>
                                                    <div>Soil Analysis</div>
                                                </div>
                                                <div className='value-container-div'>
                                                    <div>{profile.placeName}</div>
                                                    <div>{profile.fieldTypeName}</div>
                                                    <div>{maxDepth}</div>
                                                    <div>{profile.analysisDate.substring(0, 10).replace(/\//g, '-')}</div>
                                                </div>
                                                <div>
                                                    {renderPropertiesVaueList(profile.soilLayerList)}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        }
                        }
                    />
                </div>
            </Spin>
            <Modal
                open={profileDetailVisible}
                width='950px'
                onCancel={() => setProfileDetailVisible(false)}
                title={'Soil Profile Preview'}
                centered
                footer={null}
                style={{
                    width: '950px',
                    borderRadius: '16px',
                    overflow: 'hidden',
                }}
                closeIcon={<SoilCloseIcon />}
            >
                <SoilProfilePreview
                    layerDetail={layerDetail}
                    profileDetail={profileDetail}
                    profileDatailSpin={profileDatailSpin}
                    readOnly={true}
                />
            </Modal>
        </div>
    );
};

export default SoilSearchDetailComponent;